module.exports = __webpack_public_path__ + "img/planet1.b5b6fd9b.png";